import gql from 'graphql-tag';

import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {MeasurementUnit} from './__generated/MeasurementUnit';

export const DEFAULT_CONCENTRATION_UNITS = 'uM';
export const DEFAULT_VOLUME_UNITS = 'uL';
export const NULL_UNITS = 'NULL_UNITS';

/**
 * @deprecated Prefer InventoryUnitUtil.isVolumeOrNullUnit
 */
export function isVolumeOrNullUnits(units: string | null): boolean {
  if (units == null) {
    return true;
  }
  return ['L', 'mL', 'uL', 'nL', 'pL', 'gal (US)', 'qt (US)', 'pt (US)'].includes(units);
}

const MEASUREMENT_UNIT_FRAGMENT = gql`
  fragment MeasurementUnit on UnitNode {
    id
    name
    symbol
    versionNumber
    conversionFactor
    archiveData {
      archived
      purpose
    }
    unitType {
      id
      name
      terms {
        value
        exponent
      }
      overrideIsConcentration
      overrideIsContainerQuantity
    }
  }
`;

export const MeasurementUnitFragment: FragmentWrapper<MeasurementUnit> = {
  fragment: MEASUREMENT_UNIT_FRAGMENT,
  fragmentName: 'MeasurementUnit',
};

export interface Measurement {
  value: number | null;
  unit: MeasurementUnit | null;
}

/**
 * A value with units. A measurement can be partially specified (value and/or units may be null.
 */
export interface LegacyMeasurement {
  value: number | null;
  units: string | null;
}

export interface NullMeasurement {
  value: null;
  unit: null;
}

/**
 *  A measurement where both value and units are null. A null measurement is valid.
 */
export interface NullLegacyMeasurement {
  value: null;
  units: null;
}

/**
 *  A measurement where both value and units are specified.
 */
export interface NonNullLegacyMeasurement {
  value: number;
  units: string;
}

export interface NonNullMeasurement {
  value: number;
  unit: MeasurementUnit;
}

/**
 *  The result of validating a measurement with different errors (or null) for value and units.
 */
export interface MeasurementValidationResult {
  valueError: string | null;
  unitsError: string | null;
}

/**
 * A valid measurement must be either null or fully specified. Partially specified measurements are invalid.
 */
export type ValidLegacyMeasurement = NullLegacyMeasurement | NonNullLegacyMeasurement;

export type Concentration = LegacyMeasurement;
export const DEFAULT_MEASUREMENT: Measurement = {unit: null, value: null};
export const DEFAULT_LEGACY_MEASUREMENT: LegacyMeasurement = {units: null, value: null};
export const DEFAULT_MEASUREMENT_VALIDATION_RESULT = {valueError: null, unitsError: null};
